import { Tabs } from '@mantine/core';
import PricingCard from './views/PricingCard';
import { zoomSMBPlans } from './constants/SMB';
import { zoomEnterprisePlans } from './constants/Enterprise';
import { Icon } from '@iconify/react';
import { useState } from 'react';

/* eslint-disable @next/next/no-img-element */
const SectionFour = () => {
  const addOnOptions = [
    'Large Meeting',
    'Cloud Storage',
    'Translated Captions',
    'Webinars',
    'Event and Sessions',
    'Phone',
    'Revenue Accelerator',
    'Calling Plans',
    'Common Area Phones',
    'Power Pack',
    'Workspace Reservation',
    'Rooms',
    'Conference Room Connector',
    'Contact Center',
  ];

  const [activeTab, setActiveTab] = useState(1);

  return (
    <section className="bg-white">
      <div className="section-container !py-10">
        <div className="mb-[25px]">
          <img
            alt="zoom-logo"
            src="https://storage.googleapis.com/xooply-assets/cp/zoom/zoom-logo-blue.png"
            className="w-[131px] mx-auto mb-[5px]"
          />

          <h2 style={{ textIndent: '-9999px', height: '1px' }}>Zoom Workplace Bundles</h2>

          {zoomSMBPlans.map((plan, index) => (
            <h3 key={index} style={{ textIndent: '-9999px', height: '1px' }}>
              {`Zoom Workplace ${plan.type === 'ENTERPRISE' ? 'Enterprise ' : ''}${plan.title}`}
            </h3>
          ))}

          {zoomEnterprisePlans.map((plan, index) => (
            <h3 key={index} style={{ textIndent: '-9999px', height: '1px' }}>
              {`Zoom Workplace ${plan.type === 'ENTERPRISE' ? 'Enterprise ' : ''}${plan.title}`}
            </h3>
          ))}

          <p
            style={{
              marginTop: `-${zoomSMBPlans.length + zoomEnterprisePlans.length + 1}px`,
            }}
            className="text-lg lg:text-2xl font-[600] text-center"
          >
            Workplace Bundles
          </p>
        </div>

        <Tabs
          variant="unstyled"
          classNames={{
            tabsList: 'flex-nowrap min-[550px]:gap-[50px] justify-center',
            tabControl:
              'h-auto py-2.5 w-1/2 min-[550px]:w-[200px] bg-[#F2F2F2] rounded-t-[20px] text-lg min-[550px]:text-xl text-[#666666]',
            tabActive: '!bg-[#295BF6] text-white font-medium',
            body: 'p-[30px] bg-[#295BF6] rounded-b-[20px] min-[550px]:rounded-t-[20px]',
          }}
          active={activeTab}
          onTabChange={setActiveTab}
        >
          <Tabs.Tab label="SMBs">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-[30px] mb-[30px]">
              {zoomSMBPlans.map((plan, index) => (
                <PricingCard key={index} {...plan} />
              ))}
            </div>

            <div className="flex flex-col gap-5">
              <div className="flex flex-col items-center">
                <p className="text-lg font-[600] text-white text-center">
                  Add-on option for all plans
                </p>
                <p className="text-[10px] text-white text-center">
                  Enhance your Zoom Workplace experience
                </p>
              </div>

              <div className="flex flex-wrap justify-center gap-[15px]">
                {addOnOptions.map((option, index) => (
                  <div
                    key={index}
                    className="bg-white py-2.5 px-5 rounded-[10px] shadow-[0_0_10px_0_rgba(188, 188, 188, 0.6)] flex items-center gap-2.5"
                  >
                    <Icon icon="material-symbols:add-task-rounded" width={24} color="#295BF6" />

                    <p className="text-xs font-medium">{option}</p>
                  </div>
                ))}
              </div>
            </div>
          </Tabs.Tab>

          <Tabs.Tab label="Enterprise">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-[30px]">
              {zoomEnterprisePlans.map((plan, index) => (
                <PricingCard key={index} {...plan} />
              ))}
            </div>
          </Tabs.Tab>
        </Tabs>
      </div>
    </section>
  );
};

export default SectionFour;
